import { appendOfferQueryParams } from "./appendOfferQueryParams"

export type AddOfferQueryParams =
	| { newCarOrderId?: never; porscheCode?: never; reportSale?: boolean; vehicleId: string }
	| { newCarOrderId?: never; porscheCode: string; reportSale?: boolean; vehicleId?: never }
	| { newCarOrderId: string; porscheCode?: never; reportSale?: boolean; vehicleId?: never }

export const buildAddOfferUrl = (query: AddOfferQueryParams): string => appendOfferQueryParams("/offers/add", query)
